const tracks = [
  {
    id: 1,
    trackName: 'Lofi study',
    trackImg: 'https://cdn.pixabay.com/audio/2022/07/13/08-08-26-413_200x200.jpg',
    src: 'https://cdn.pixabay.com/download/audio/2022/05/27/audio_1808fbf07a.mp3?filename=lofi-study-112191.mp3'
  },
  {
    id: 2,
    trackName: 'Empty mind',
    trackImg: 'https://cdn.pixabay.com/audio/2022/09/02/21-42-13-13_200x200.jpg',

    src: 'https://cdn.pixabay.com/download/audio/2022/09/02/audio_72502a492a.mp3?filename=empty-mind-118973.mp3'
  },
  {
    id: 3,
    trackName: 'Asthetics',
    trackImg: 'https://cdn.pixabay.com/audio/2023/02/09/23-39-22-228_200x200.jpg',

    src: 'https://cdn.pixabay.com/download/audio/2023/02/09/audio_3a7b04f698.mp3?filename=aesthetics-138637.mp3'
  },
  {
    id: 4,
    trackName: 'Sleepy cat',
    trackImg: 'https://cdn.pixabay.com/audio/2022/09/02/21-41-57-430_200x200.jpg',

    src: 'https://cdn.pixabay.com/download/audio/2022/09/02/audio_4dd705d8e5.mp3?filename=sleepy-cat-118974.mp3'
  },
  {
    id: 5,
    trackName: 'Chill beat',
    trackImg: 'https://cdn.pixabay.com/audio/2022/10/22/07-58-25-941_200x200.jpg',
    src: 'https://cdn.pixabay.com/download/audio/2022/10/22/audio_e037c90cbb.mp3?filename=untitled-123636.mp3'
  },
  {
    id: 6,
    trackName: 'Rain pouring',
    trackImg: 'https://cdn.pixabay.com/audio/2022/08/14/09-10-10-967_200x200.jpg',
    src: 'https://cdn.pixabay.com/download/audio/2022/08/14/audio_9289a45f56.mp3?filename=in-the-room-when-the-rain-pouring-117209.mp3'
  },
  {
    id: 7,
    trackName: 'The bank',
    trackImg: 'https://cdn.pixabay.com/audio/2022/07/17/03-24-22-453_200x200.jpg',
    src: 'https://cdn.pixabay.com/download/audio/2022/07/17/audio_9e63152ebb.mp3?filename=lofi-in-the-bank-115135.mp3'
  },
  {
    id: 8,
    trackName: 'Coding Night',
    trackImg: 'https://cdn.pixabay.com/audio/2022/07/13/08-08-42-285_200x200.jpg',
    src: 'https://cdn.pixabay.com/download/audio/2022/05/27/audio_d65ec060b3.mp3?filename=coding-night-112186.mp3'
  },
  {
    id: 9,
    trackName: 'SloMo',
    trackImg: 'https://cdn.pixabay.com/audio/2023/01/19/00-37-49-501_200x200.jpg',
    src: 'https://cdn.pixabay.com/download/audio/2023/01/19/audio_2b284cdbd4.mp3?filename=slomo-135807.mp3'
  },
  {
    id: 10,
    trackName: 'Calm study',
    trackImg: 'https://cdn.pixabay.com/audio/2022/10/16/11-58-33-335_200x200.jpg',
    src: 'https://cdn.pixabay.com/download/audio/2022/10/16/audio_ffa3e91f8b.mp3?filename=close-study-relax-chillhop-calm-study-lofi-123089.mp3'
  }
];

export default tracks;
